<template>
  <main>
    <section id="parallax" class="section--full section--banner overlayed" @mousemove="parallax"> 
      <video autoplay muted playsinline loop class="section__video">
        <source src="@/assets/video/digitalcareer.mp4" type="video/mp4">
      </video>
    </section>
    <section class="container container--short">
      <div class="container--white">
        <h2 class="heading-detail">MNC Digital Career Fest</h2>
        <div class="details">
          <p class="description">
            Dalam rangka menyambut HUT MNC Group yang ke 32, Group Hiring menyelenggarakan Virtual Job Fair bertema Digital Career Fest.  Merupakan virtual job fair kami yang ke -2. 
            Virtual job fair ini diadakan untuk menjaring talenta-talenta potential untuk mengisi lebih dari 50  
            lowongan kerja digital antara lain untuk posisi IT Developer, Data Scientist, Mobile Application, Games Developer,
            Digital Marketing, Digital sales dll.
          </p>
        </div>
  
        <div class="details">
          <img class="md-image" src="@/assets/images/digitalcareer.jpg" alt="">
        </div>

        <div class="details">
          <div class="font-title">Waktu Pelaksanaan :</div>
          <br>
          <p class="description">
            1-5 November 2021 di <a href="https://www.jobsmnc.co.id/" class="link" target="_blank">www.jobsmnc.co.id</a>
          </p>
        </div>

        <div class="details">
          <div class="font-title">Syarat & Ketentuan :</div>
          <br>
          <ol class="mg-left-35">
            <li class="description list-block">Peserta sudah mempunyai ijazah minimum S1</li>
            <li class="description list-block">Mempunyai pengalaman kerja minimal 3 tahun di bidangnya</li>
          </ol>
        </div>

        <div class="details">
          <div class="font-title">Cara Mengikuti Virtual Jobfair :</div>
          <br>
          <ol class="mg-left-35">
            <li class="description list-block">Buka <a class="link" href="https://www.jobsmnc.co.id/" target="_blank">www.jobsmnc.co.id</a></li>
            <li class="description list-block">Mengisi application form</li>
            <li class="description list-block">Memilih lowongan kerja yang sesuai</li>
          </ol>
        </div>

  
        <!-- <div class="grid grid--three details">
          <div>
            <img src="https://images.unsplash.com/photo-1579227114347-15d08fc37cae?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1553729459-efe14ef6055d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1170&q=80" alt="">
          </div>
          <div>
            <img src="https://images.unsplash.com/photo-1518183214770-9cffbec72538?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80" alt="">
          </div>
        </div> -->

      </div>
    </section>
  </main>
</template>

<script>
import parallax from '@/commons/parallax.js'

export default {
  name: 'DetailDigitalCareer',
  methods: {
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    }
  }
}
</script>